export default __webpack_public_path__ + "static/media/logo.329dc202.png";